import styled from 'styled-components';
import { CSSProperties } from 'react';

import { Colors, FontSize, FontWeight } from '../../app/styles/theme';

type TitleProps = {
	color?: Colors;
	variant?: FontSize;
	weight?: FontWeight;
	align?: CSSProperties['textAlign'];
};

export const Title = styled.h1<TitleProps>`
	margin: 0;
	color: ${({ theme, color }) => theme.color[color as Colors]};
	font-weight: ${({ theme, weight }) =>
		theme.typography.weight[weight as FontWeight]};
	font-size: ${({ theme, variant }) =>
		theme.typography.size[variant as FontSize]}px;
	text-align: ${({ align }) => align};
`;

Title.defaultProps = {
	color: 'text',
	variant: 'h1',
	weight: 'black',
	align: 'left',
};
